import * as BABYLON from 'babylonjs'
import { objectConfigurations, inspectorClic, pantallas } from '@/core/utils.js'
import { Pantalla } from '@/core/Pantalla.js'

export function culturalCenter (hObject) {
  var materialCristalesEdificio = new BABYLON.StandardMaterial('materialCercaNatural', window.scene)
  materialCristalesEdificio.emissiveTexture = new BABYLON.Texture('static/textures/ventanalesEdificio.png', window.scene)
  materialCristalesEdificio.emissiveTexture.uScale = 2.0
  materialCristalesEdificio.emissiveTexture.vScale = 60.0
  materialCristalesEdificio.backFaceCulling = false
  materialCristalesEdificio.reflectionTexture = new BABYLON.MirrorTexture('mirror', 512, window.scene, true)
  materialCristalesEdificio.reflectionTexture.mirrorPlane = new BABYLON.Plane(0, -1.0, 0, -10.0)
  materialCristalesEdificio.reflectionTexture = new BABYLON.CubeTexture('static/textures/TropicalSunnyDay', window.scene)
  materialCristalesEdificio.reflectionTexture.level = 0.75 // Select the level (0.0 > 1.0) of the reflection
  BABYLON.SceneLoader.ImportMesh('', 'static/assets/Centro-cultural/', 'Centro-cultural.babylon', window.scene, function (newMeshes, particleSystems) {
    var i
    objectConfigurations(hObject, newMeshes)

    newMeshes[14].material = materialCristalesEdificio

    newMeshes[3].material.reflectionTexture = new BABYLON.MirrorTexture('mirror', 512, window.scene, true)
    newMeshes[3].material.reflectionTexture.mirrorPlane = new BABYLON.Plane(0, -1.0, 0, -10.0)
    newMeshes[3].material.reflectionTexture = new BABYLON.CubeTexture('static/textures/TropicalSunnyDay', window.scene)
    newMeshes[3].material.reflectionTexture.level = 0.4 // Select the level (0.0 > 1.0) of the reflection
    // newMeshes[3].material.reflectionTexture.renderList = [newMeshes[1], newMeshes[2]]

    for (i = 0; i < newMeshes.length; i++) {
      if (i !== 14) {
        newMeshes[i].addLODLevel(1000, null)
      }
    }
  })
}

export function standSPE (hObject) {
  // STAND SPE
  BABYLON.SceneLoader.ImportMesh('', 'static/assets/standspe/', 'standspe.babylon', window.scene, function (newMeshes, particleSystems) {
    var materialTapete = new BABYLON.StandardMaterial('tapete', window.scene)
    materialTapete.emissiveTexture = new BABYLON.Texture('static/textures/tapete.jpg', window.scene)

    materialTapete.emissiveTexture.uScale = 5.0
    materialTapete.emissiveTexture.vScale = 5.0

    var baseStandSpe = BABYLON.MeshBuilder.CreatePlane('base-standspe', {width: 30, height: 40}, window.scene)
    baseStandSpe.position.x = 0
    baseStandSpe.position.z = -365
    baseStandSpe.position.y = 0.25
    baseStandSpe.rotation.x = 90 * Math.PI / 4
    baseStandSpe.checkCollisions = true

    baseStandSpe.material = window.scene.getMaterialByName('materialTapete')

    var i, j

    newMeshes = inspectorClic(newMeshes)

    // Emparentando instancias
    for (i = 0; i < newMeshes.length; i++) {
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        newMeshes[i].instances[j].parent = newMeshes[15]
      }
    }
    // Emparentando
    for (i = 0; i < newMeshes.length; i++) {
      if (i !== 15) {
        newMeshes[i].parent = newMeshes[15]
      }
    }
    // for (i = 0; i < newMeshes.length; i++) {
    //   if (i !== 15) {
    //     newMeshes[i].position.z = newMeshes[i].position.z - 30
    //     newMeshes[i].position.y = newMeshes[i].position.y - 0.4
    //   }
    //   for (j = 0; j < newMeshes[i].instances.length; j++) {
    //     newMeshes[i].instances[j].position.z = newMeshes[i].instances[j].position.z - 30
    //     newMeshes[i].instances[j].position.y = newMeshes[i].instances[j].position.y + 0.4
    //   }
    // }

    newMeshes[15].position.z = -400
    newMeshes[15].position.y = 0.4
    newMeshes[15].visibility = false

    for (i = 0; i < newMeshes.length; i++) {
      newMeshes[i].checkCollisions = true
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        newMeshes[i].instances[j].checkCollisions = true
      }
    }

    newMeshes[2].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[2].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://www.buscadordeempleo.gov.co/', '_blank')
    }))
    newMeshes[3].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[3].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://www.buscadordeempleo.gov.co/', '_blank')
    }))

    newMeshes[12].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[12].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://personas.serviciodeempleo.gov.co/login.aspx', '_blank')
    }))
    newMeshes[13].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[13].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://personas.serviciodeempleo.gov.co/login.aspx', '_blank')
    }))
    newMeshes[0].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[0].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://personas.serviciodeempleo.gov.co/login.aspx', '_blank')
    }))
    newMeshes[1].actionManager = new BABYLON.ActionManager(window.scene)
    newMeshes[1].actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      window.open('http://personas.serviciodeempleo.gov.co/login.aspx', '_blank')
    }))

    pantallas[pantallas.length] = new Pantalla(newMeshes[20], 'https://husmind.com/media/videos-spe/entrevista.mp4.mp4', 5, false, true, true) // PANTALLAS IZQUIERDA 18 HERMANA
    pantallas[pantallas.length - 1].addPantalla(newMeshes[18])

    pantallas[pantallas.length] = new Pantalla(newMeshes[28], 'https://husmind.com/media/videos-spe/rumboalapazclara.mp4.mp4', 8, true, false, true) // PANTALLA CENTRAL DELANTERA
    pantallas[pantallas.length - 1].addPantalla(newMeshes[22]) // PANTALLA CENTRAL TRACERA

    pantallas[pantallas.length] = new Pantalla(newMeshes[21], 'https://husmind.com/media/videos-spe/mujeres.mp4.mp4', 5, false, true, true) // PANTALLAS DERECHA 27 HERMANA
    pantallas[pantallas.length - 1].addPantalla(newMeshes[27])
  })
}



// WEBPACK FOOTER //
// ./src/core/types.js